<template>
  <div>
    <!-- 头部 -->
    <div class="head">区域：{{ areaName }}</div>
    <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
      <el-tab-pane label="任务管理" name="first" v-if="check_auth('/web/task/get_list')">
        <!-- 任务管理 -->
        <!-- 搜索筛选 -->
        <div class="elTable">
          <el-form :inline="true" :model="formInline" style="margin-top: 20px; heigth: 60px">
            <el-form-item label="搜索：">
              <el-input size="small" v-model="formInline.name" placeholder="请输入任务名称"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
              <el-button size="small" type="success" icon="el-icon-plus" @click="addTask"
                v-if="check_auth('/web/task/add')">新建任务</el-button>
            </el-form-item>
          </el-form>
          <!--列表-->
          <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border
            element-loading-text="拼命加载中" style="width: 100%">
            <!-- <el-table-column align="center" prop="id" label="ID" width="80"></el-table-column> -->
            <el-table-column align="center" prop="name" label="任务名称" min-width="200"></el-table-column>
            <el-table-column align="center" prop="line_name" label="线路名称" min-width="250"></el-table-column>
            <el-table-column align="center" prop="vin" label="执行车辆" min-width="200"></el-table-column>
            <el-table-column align="center" prop="water_status" label="洒水状态" min-width="100">
              <template slot-scope="scope">
                <el-tag type="success" v-if="scope.row.water_status == '开启'">{{ scope.row.water_status }}</el-tag>
                <el-tag type="info" v-else>{{ scope.row.water_status }}</el-tag>
              </template>
            </el-table-column>
            <el-table-column align="center" prop="clear_status" label="清扫状态" min-width="100">
              <template slot-scope="scope">
                <el-tag type="success" v-if="scope.row.clear_status == '开启'">{{ scope.row.clear_status }}</el-tag>
                <el-tag type="info" v-else>{{ scope.row.clear_status }}</el-tag>
              </template>
            </el-table-column>
            <el-table-column align="center" prop="water_level" label="水位阈值" min-width="80"></el-table-column>
            <el-table-column align="center" prop="electricity_level" label="电量阈值" min-width="80"></el-table-column>
            <el-table-column align="center" prop="online" label="车辆状态" min-width="100">
              <template slot-scope="scope">
                <el-tag type="success" v-if="scope.row.online == '在线'">{{ scope.row.online }}</el-tag>
                <el-tag type="info" v-else>{{ scope.row.online }}</el-tag>
              </template>
            </el-table-column>
            <el-table-column align="center" prop="run_count" label="运行次数" min-width="80"></el-table-column>
            <el-table-column align="center" prop="status" label="任务状态" min-width="100">
              <template slot-scope="scope">
                <el-tag :color="scope.row.statusType" style="color:white">{{
                  scope.row.status
                }}</el-tag>
              </template>
            </el-table-column>
            <el-table-column align="center" prop="stop_time" label="停靠时间" min-width="80"><template slot-scope="scope">
                {{ scope.row.stop_time }}s
              </template></el-table-column>
            <el-table-column align="center" prop="start_time" label="开始时间" min-width="200">
            </el-table-column>
            <el-table-column align="center" prop="end_time" label="结束时间" min-width="200">
            </el-table-column>
            <el-table-column align="center" prop="remark" label="备注" min-width="250"></el-table-column>
            <el-table-column align="center" fixed="right" label="操作" width="350">
              <template slot-scope="scope">
                <!-- <el-button size="mini">{{scope.row.status}}</el-button> -->
                <el-button size="mini" @click="editTask(scope.row)" round
                  :disabled="scope.row.status == '未开始' || scope.row.status == '未知' || scope.row.status == '已终止' ? false : true"
                  v-if="check_auth('/web/task/edit_task')">
                  编辑</el-button>
                <el-button size="mini" type="success" round
                  :disabled="scope.row.status == '进行中' && scope.row.belong == 1 ? false : true"
                  v-if="scope.row.status == '暂停' || scope.row.status == '已到站' ? false : true"
                  @click="suspendStatus(scope.row)">暂停
                </el-button>
                <el-button size="mini" type="success" round v-else @click="suspendStatus(scope.row)">继续
                </el-button>
                <el-button size="mini" type="primary" :disabled="scope.row.status == '未知' ? true : false"
                  v-if="scope.row.status == '未开始' || scope.row.status == '已终止' || scope.row.status == '未知' && scope.row.belong == 1 || scope.row.belong == '未知' ? true : false"
                  round @click="changeStatus(scope.row)">
                  启动
                </el-button>
                <el-button size="mini" type="warning" round v-else @click="changeStatus(scope.row)">终止
                </el-button>
                <el-button size="mini" type="danger" @click="deleteUser(scope.row)" round
                  :disabled="scope.row.status == '未开始' || scope.row.status == '未知' || scope.row.status == '已终止' ? false : true"
                  v-if="check_auth('/web/task/del_task')">
                  删除</el-button>
              </template>
            </el-table-column>
          </el-table>
          <!-- 分页组件 -->
          <Pagination v-bind:child-msg="pageparm" @callFather="callFather">
          </Pagination>
        </div>
        <!-- 添加 -->
        <el-dialog title="添加" :visible.sync="dialogVisibleFrom" width="35%" @close="closeDialog" top="10px"
          :destroy-on-close="true" :close-on-click-modal="false">
          <el-form label-width="15%" :model="addForm" ref="addForm" :rules="rules">
            <el-form-item label="任务名称" prop="name">
              <el-input size="small" v-model="addForm.name" auto-complete="off" placeholder="请输入任务名称" clearable>
              </el-input>
            </el-form-item>
            <el-form-item label="选择车辆" prop="vin">
              <div class="chooseMap">
                <div @click="selectCar" class="in_chooseMap">
                  <div style="margin-left: 3%">{{ addForm.vin }}</div>
                  <div style="float: right">></div>
                </div>
              </div>
            </el-form-item>
            <el-form-item label="地图选择" prop="map_name_cn">
              <div class="chooseMap">
                <div @click="selectMap" class="in_chooseMap">
                  <div style="margin-left: 3%">{{ addForm.map_name_cn }}</div>
                  <div style="float: right">></div>
                </div>
              </div>
            </el-form-item>
            <el-form-item v-if="routeShow" label="线路选择" prop="line_name">
              <div class="chooseMap">
                <div @click="selectLine" class="in_chooseMap">
                  <div style="margin-left: 3%">{{ addForm.line_name }}</div>
                  <div style="float: right">></div>
                </div>
              </div>
            </el-form-item>
            <el-form-item label="是否开启洒水" prop="water_status" label-width="100%" style="float:left;margin-left: 25px;">
              <el-switch v-model="addForm.water_status"></el-switch>
            </el-form-item>
            <el-form-item label="是否开启清扫" prop="clear_status" label-width="40%">
              <el-switch v-model="addForm.clear_status"></el-switch>
            </el-form-item>
            <el-form-item label="水位阈值" :rules="addForm.water_status ? rules.water_level : []" prop="water_level">
              <el-input size="small" v-model="addForm.water_level" auto-complete="off" :disabled="!addForm.water_status"
                placeholder="请输入水位阈值" clearable>
              </el-input>
            </el-form-item>
            <el-form-item label="电量阈值" prop="electricity_level">
              <el-input size="small" v-model="addForm.electricity_level" auto-complete="off" placeholder="请输入电量阈值"
                clearable>
              </el-input>
            </el-form-item>
            <el-form-item label="停靠时间(s)" prop="stop_time">
              <el-input size="small" v-model="addForm.stop_time" auto-complete="off" placeholder="请输入停靠时间" clearable>
              </el-input>
            </el-form-item>
            <el-form-item label="开始时间" prop="create_time">
              <el-date-picker style="width: 100%" v-model="addForm.create_time" size="small" type="datetimerange"
                align="right" start-placeholder="开始日期" end-placeholder="结束日期" :default-time="['08:00:00', '17:00:00']"
                value-format="yyyy-MM-dd HH:mm:ss">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="运行次数" prop="run_count">
              <el-input size="small" v-model="addForm.run_count" auto-complete="off" placeholder="请输入运行次数" clearable>
              </el-input>
            </el-form-item>
            <el-form-item label="备注" prop="remark">
              <el-input type="textarea" rows="3" size="small" v-model="addForm.remark" auto-complete="off"
                placeholder="请输入备注">
              </el-input>
            </el-form-item>
          </el-form>
          <div style="margin-top: 0" slot="footer" class="dialog-footer">
            <el-button size="small" @click="closeDialog">取消</el-button>
            <el-button size="small" type="primary" :loading="loading" @click="submitAddForm('addForm')">保存
            </el-button>
          </div>
          <!-- 添加内层选择车辆 -->
          <el-dialog width="35%" title="选择车辆" :visible.sync="innerVisibleCar" append-to-body
            :close-on-click-modal="false">
            <el-form :inline="true" :model="carMapInline" class="user-search1">
              <el-form-item label="搜索：">
                <el-input size="small" v-model="carMapInline.vin" placeholder="请输入车辆编号" clearable></el-input>
              </el-form-item>
              <el-form-item>
                <el-button size="small" type="primary" icon="el-icon-search" @click="searchCar">搜索</el-button>
              </el-form-item>
              <el-form-item>
                <el-button size="small" type="primary" @click="chooseCar">确定</el-button>
              </el-form-item>
            </el-form>
            <el-table :data="carData" tooltip-effect="dark" style="width: 100%" ref="multipleTableCar"
              @select-all="onSelectAllCar" @selection-change="selectItemCar" @row-click="onSelectOpCar">
              <el-table-column type="selection" width="55"> </el-table-column>
              <el-table-column prop="vin" label="车辆编号" align="center" min-width="200">
              </el-table-column>
              <el-table-column prop="car_number" align="center" min-width="150" label="车牌号" show-overflow-tooltip>
              </el-table-column>
            </el-table>
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
              :current-page="pagetwo.currentPage" :page-size="pagetwo.pageSize" background :pager-count="5"
              layout="total, prev, pager, next" :total="pagetwo.total">
            </el-pagination>
          </el-dialog>
          <!-- --------选择车辆结束 -->
          <!-- 添加内层选择地图 -->
          <el-dialog width="35%" title="选择地图" :visible.sync="innerVisibleMap" append-to-body
            :close-on-click-modal="false">
            <el-form :inline="true" :model="carMapInline" class="user-search1">
              <el-form-item label="搜索：">
                <el-input size="small" v-model="carMapInline.map_name_cn" placeholder="请输入地图名称" clearable></el-input>
              </el-form-item>
              <el-form-item>
                <el-button size="small" type="primary" icon="el-icon-search" @click="searchMap">搜索</el-button>
              </el-form-item>
              <el-form-item>
                <el-button size="small" type="primary" @click="chooseMap">确定</el-button>
              </el-form-item>
            </el-form>
            <el-table :data="gridData" tooltip-effect="dark" style="width: 100%" ref="multipleTableMap"
              @select-all="onSelectAllMap" @selection-change="selectItemMap" @row-click="onSelectOpMap">
              <el-table-column type="selection" width="55"> </el-table-column>
              <el-table-column prop="id" align="center" label="地图编号" min-width="120">
              </el-table-column>
              <el-table-column prop="map_name_cn" label="地图名称" align="center" show-overflow-tooltip>
              </el-table-column>
            </el-table>
            <el-pagination @size-change="handleMapSizeChange" @current-change="handleMapCurrentChange"
              :current-page="pagetwo.currentPage" :page-size="pagetwo.pageSize" background :pager-count="5"
              layout="total, prev, pager, next" :total="pagetwo.total">
            </el-pagination>
          </el-dialog>
          <!-- -------结束 -->
          <!-- 内层选择线路 -->
          <el-dialog width="35%" title="选择线路" :visible.sync="innerVisibleRouteLine" append-to-body
            @close="closeLineDialog" :close-on-click-modal="false">
            <el-form :inline="true" :model="carMapInline" class="user-search1">
              <el-form-item label="搜索：">
                <el-input size="small" v-model="carMapInline.name_cn" placeholder="请输入线路名称" clearable=""></el-input>
              </el-form-item>
              <el-form-item>
                <el-button size="small" type="primary" icon="el-icon-search" @click="searchLine">搜索</el-button>
              </el-form-item>
              <el-form-item>
                <el-button size="small" type="primary" @click="chooseRoute">确定</el-button>
              </el-form-item>
            </el-form>
            <el-table ref="multipleTablesLine" :data="lineData" @selection-change="handleSelectionChange" row-key="id">
              <el-table-column align="center" width="50" type="selection" reserve-selection></el-table-column>
              <el-table-column align="center" prop="id" label="线路编号" width="80"></el-table-column>
              <el-table-column align="center" prop="name_cn" label="线路名称" min-width="200"></el-table-column>
            </el-table>
            <el-pagination @size-change="handleLineSizeChange" @current-change="handleLineCurrentChange"
              :current-page="pagetwo.currentPage" :page-size="pagetwo.pageSize" background :pager-count="5"
              layout="total ,prev, pager, next" :total="pagetwo.total">
            </el-pagination>
          </el-dialog>
          <!-- 内层选择线路-->
        </el-dialog>
        <!-- 编辑界面 -->
        <el-dialog title="编辑" :visible.sync="dialogVisible" width="35%" @close="closeDialog" top="10px"
          :close-on-click-modal="false">
          <el-form label-width="15%" :model="editForm" :rules="rules" ref="editForm">
            <el-form-item label="任务名称" prop="name">
              <el-input size="small" v-model="editForm.name" auto-complete="off" placeholder="请输入任务名称" clearable>
              </el-input>
            </el-form-item>
            <el-form-item label="选择车辆" prop="vin">
              <div class="chooseMap">
                <div @click="selectEditCar" class="in_chooseMap">
                  <div style="margin-left: 3%">{{ editForm.vin }}</div>
                  <div style="float: right">></div>
                </div>
              </div>
            </el-form-item>
            <el-form-item label="地图选择" prop="map_name_cn">
              <div class="chooseMap">
                <div @click="selectEditMap" class="in_chooseMap">
                  <div style="margin-left: 3%">{{ editForm.map_name_cn }}</div>
                  <div style="float: right">></div>
                </div>
              </div>
            </el-form-item>
            <el-form-item v-if="routeShow" label="线路选择" prop="line_name">
              <div class="chooseMap">
                <div @click="selectEditLine" class="in_chooseMap">
                  <div style="margin-left: 3%">{{ editForm.line_name }}</div>
                  <div style="float: right">></div>
                </div>
              </div>
            </el-form-item>
            <el-form-item label="是否开启洒水" prop="water_status" label-width="100%" style="float: left;margin-left: 25px;">
              <el-switch v-model="editForm.water_status"></el-switch>
            </el-form-item>
            <el-form-item label="是否开启清扫" prop="clear_status" label-width="40%">
              <el-switch v-model="editForm.clear_status"></el-switch>
            </el-form-item>
            <el-form-item label="水位阈值" :rules="editForm.water_status ? rules.water_level : []" prop="water_level">
              <el-input size="small" v-model="editForm.water_level" auto-complete="off" :disabled="!editForm.water_status"
                placeholder="请输入水位阈值" clearable>
              </el-input>
            </el-form-item>
            <el-form-item label="电量阈值" prop="electricity_level">
              <el-input size="small" v-model="editForm.electricity_level" auto-complete="off" placeholder="请输入电量阈值"
                clearable>
              </el-input>
            </el-form-item>
            <el-form-item label="停靠时间(s)" prop="stop_time">
              <el-input size="small" v-model="editForm.stop_time" auto-complete="off" placeholder="请输入停靠时间" clearable>
              </el-input>
            </el-form-item>
            <el-form-item label="开始时间" prop="create_time">
              <el-date-picker style="width: 100%" v-model="editForm.create_time" clearable type="datetimerange"
                align="right" start-placeholder="开始日期" end-placeholder="结束日期" :default-time="['08:00:00', '17:00:00']"
                value-format="yyyy-MM-dd HH:mm:ss">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="运行次数" prop="run_count">
              <el-input size="small" v-model="editForm.run_count" auto-complete="off" placeholder="请输入运行次数" clearable>
              </el-input>
            </el-form-item>
            <el-form-item label="备注" prop="remark">
              <el-input type="textarea" rows="3" size="small" v-model="editForm.remark" auto-complete="off"
                placeholder="请输入备注">
              </el-input>
            </el-form-item>
          </el-form>
          <div style="margin-top: 0" slot="footer" class="dialog-footer">
            <el-button size="small" @click="closeDialog">取消</el-button>
            <el-button size="small" type="primary" :loading="loading" @click="submitForm('editForm')">保存
            </el-button>
          </div>

          <!-- 编辑内层选择车辆 -->
          <el-dialog width="35%" title="选择车辆" :visible.sync="innerVisibleCarEdit" append-to-body
            :close-on-click-modal="false">
            <el-form :inline="true" :model="carMapInline" class="user-search1">
              <el-form-item label="搜索：">
                <el-input size="small" v-model="carMapInline.vin" placeholder="请输入车辆编号" clearable></el-input>
              </el-form-item>
              <el-form-item>
                <el-button size="small" type="primary" icon="el-icon-search" @click="searchEditCar">搜索</el-button>
              </el-form-item>
              <el-form-item>
                <el-button size="small" type="primary" @click="chooseEditCar">确定</el-button>
              </el-form-item>
            </el-form>
            <el-table :data="carEditData" tooltip-effect="dark" style="width: 100%" ref="multipleTableCars"
              @select-all="onSelectAllCarEdit" @selection-change="selectItemCarEdit" @row-click="onSelectOpCarEdit">
              <el-table-column type="selection" width="55"> </el-table-column>

              <el-table-column prop="vin" label="车辆编号" align="center" width="200">
              </el-table-column>
              <el-table-column prop="car_number" align="center" label="车牌号" show-overflow-tooltip>
              </el-table-column>
            </el-table>
            <el-pagination @size-change="handleEditSizeChange" @current-change="handleEditCurrentChange"
              :current-page="pagetwo.currentPage" :page-size="pagetwo.pageSize" background :pager-count="5"
              layout="total, prev, pager, next" :total="pagetwo.total">
            </el-pagination>
          </el-dialog>
          <!-- --------选择车辆结束 -->
          <!-- 编辑内层选择地图 -->
          <el-dialog width="35%" title="选择地图" :visible.sync="innerVisibleMapEdit" append-to-body @click="closeDialog"
            :destroy-on-close="true" :close-on-click-modal="false">
            <el-form :inline="true" :model="carMapInline" class="user-search1">
              <el-form-item label="搜索：">
                <el-input size="small" v-model="carMapInline.map_name_cn" placeholder="请输入地图名称" clearable></el-input>
              </el-form-item>
              <el-form-item>
                <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
              </el-form-item>
              <el-form-item>
                <el-button size="small" type="primary" @click="chooseEditMap">确定</el-button>
              </el-form-item>
            </el-form>
            <el-table :data="gridData" tooltip-effect="dark" style="width: 100%" ref="multipleTableMaps"
              @select-all="onSelectAllMapEdit" @selection-change="selectItemMapEdit" @row-click="onSelectOpMapEdit">
              <el-table-column type="selection" width="55"> </el-table-column>
              <el-table-column prop="id" align="center" label="地图编号" show-overflow-tooltip>
              </el-table-column>
              <el-table-column prop="map_name_cn" align="center" label="地图名称" width="200">
              </el-table-column>
            </el-table>
            <el-pagination @size-change="handleMapSizeChange" @current-change="handleMapCurrentChange"
              :current-page="pagetwo.currentPage" :page-size="pagetwo.pageSize" background :pager-count="5"
              layout="total, prev, pager, next" :total="pagetwo.total">
            </el-pagination>
          </el-dialog>
          <!-- -------结束 -->

          <!-- 编辑内层选择线路 -->
          <el-dialog width="35%" title="选择线路" :visible.sync="innerVisibleRoute" append-to-body
            @close="closeLineEditDialog" :close-on-click-modal="false">
            <el-form :inline="true" :model="carMapInline" class="user-search1">
              <el-form-item label="搜索：">
                <el-input size="small" v-model="carMapInline.name_cn" placeholder="请输入线路名称" clearable></el-input>
              </el-form-item>
              <el-form-item>
                <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
              </el-form-item>
              <el-form-item>
                <el-button size="small" type="primary" @click="chooseEditRoute">确定</el-button>
              </el-form-item>
            </el-form>
            <el-table ref="multipleTables" :data="lineData" @selection-change="handleSelectionChange" row-key="id">
              <el-table-column align="center" width="50" type="selection" reserve-selection></el-table-column>
              <el-table-column align="center" prop="id" label="线路编号"></el-table-column>
              <el-table-column align="center" prop="name_cn" label="线路名称" width="200"></el-table-column>
            </el-table>
            <el-pagination @size-change="handleLinesSizeChange" @current-change="handleLinesCurrentChange"
              :current-page="pagetwo.currentPage" :page-sizes="[10, 15, 25, 50, 100]" :page-size="pagetwo.pageSize"
              background :pager-count="5" layout="total, prev, pager, next" :total="pagetwo.total">
            </el-pagination>
          </el-dialog>
          <!-- 内层选择线路-->
        </el-dialog>
        <!-- 任务管理结束 -->
      </el-tab-pane>
      <el-tab-pane label="区域车辆" name="second" v-if="check_auth('/web/area/get_area_cars')">
        <car ref="child" />
      </el-tab-pane>
      <el-tab-pane label="区域线路" name="third" v-if="check_auth('/web/area/get_area_line')">
        <areaLine ref="childer" />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import car from "../region_mn/area_car";
import areaLine from "../region_mn/line";
import {
  auth
} from "../../utils/util";
import {
  get_task_list,
  get_cars_task,
  get_cars_task_edit,
  get_map_task,
  get_line_task,
  get_add_task,
  get_one_task,
  get_edit_task,
  get_switch_status,
  get_del_task,
} from "../../api/region/area_task";
import Pagination from "../../components/Pagination";
export default {
  name: "task",
  props: [
    "areaName",
  ],
  data() {
    return {
      dialogVisibleFrom: false,
      dialogVisible: false,
      routeShow: false,
      start: true,
      task_status: "测试",
      multipleSelection: [],
      idsval: [],
      ids: [],
      line_names: [],
      kongzhi: false,
      //车辆选择
      carData: [],
      carEditData: [],
      // 地图选择
      gridData: [],
      lineData: [],
      destroy: false,
      dialogChooseCar: false,
      innerVisibleCar: false,
      innerVisibleRoute: false,
      innerVisibleRouteLine: false,
      innerVisibleMap: false,
      innerVisibleMapEdit: false,
      innerVisibleCarEdit: false,
      activeName: "first",
      nshow: true, //switch开启
      fshow: false, //switch关闭
      loading: false, //是显示加载
      timerLoad: "",
      timer: "",
      addForm: {
        electricity_level: "",
        water_status: false,
        clear_status: false,
        id: "",
        name: "",
        vin: "",
        map_id: "",
        map_name_cn: "",
        line_id: "",
        line_name: "",
        remark: "",
        water_level: 0,
        create_time: [],
        stop_time: "",
        run_count: "",
      },
      editForm: {
        electricity_level: "",
        water_status: false,
        clear_status: false,
        id: "",
        name: "",
        vin: "",
        map_id: "",
        map_name_cn: "",
        line_id: "",
        line_name: "",
        remark: "",
        water_level: "",
        create_time: [],
        stop_time: "",
        end_time: "",
        run_count: "",
      },

      // rules表单验证
      rules: {
        name: [{ required: true, message: "请输入任务名称", trigger: "blur" }],
        vin: [{ required: true, message: "请选择执行车辆", trigger: "blur" }],
        map_name_cn: [
          { required: true, message: "请选择地图", trigger: "blur" },
        ],
        line_name: [
          { required: true, message: "请选择线路", trigger: "blur" },
        ],
        water_level: [
          { required: true, message: "请输入水位阈值", trigger: "blur" },
        ],
        electricity_level: [
          { required: true, message: "请输入电量阈值", trigger: "blur" },
        ],
        run_count: [
          { required: true, message: "请输入运行次数", trigger: "blur" },
        ],
        create_time: [
          {
            required: true,
            message: "请选择时间",
            trigger: "change",
          },
        ],
        stop_time: [
          { required: true, message: "请输入停靠时间", trigger: "blur" },
          {
            pattern: /^\d+$|^\d+[.]?\d+$/,
            message: "请输入正整数",
            trigger: "blur",
          },
        ],
      },
      formInline: {
        page: 1,
        limit: 10,
        name: "",
      },
      carMapInline: {
        page: 1,
        limit: 10,
        vin: "",
        map_name_cn: "",
        name_cn: "",
      },
      listData: [], //用户数据
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10,
      },
      // 导入车辆分页参数
      pagetwo: {
        currentPage: 1,
        pageSize: 10,
        total: 10,
      },
    };
  },

  // 注册组件
  components: {
    Pagination,
    car,
    areaLine,
  },
  /**
   * 创建完毕
   */
  mounted() {
    this.$nextTick(function () {
      this.$on("childmethod", function () {
        this.getTaskData();
        this.timer = setInterval(() => {
          this.getTaskData();
        }, 2000)
        this.activeName = "first";
      });
    });
    // this.getTaskData();
  },
  methods: {
    childmethod() { },
    // 任务列表
    getTaskData() {
      get_task_list(this.formInline).then((res) => {
        if (res["code"] === 0) {
          this.listData = res.data.data;
          for (let i = 0; i < this.listData.length; i++) {
            this.listData[i].statusType = {
              "初始": "#909399",
              "执行中": "#67C23A",
              "暂停": "#409EFF",
              "车辆到站": "#E6A23C",
              "结束": "#F56C6C",
              "未知": "#909399",
            }[this.listData[i].status]
            this.listData[i].status = {
              "初始": "未开始",
              "执行中": "进行中",
              "暂停": "暂停",
              "车辆到站": "已到站",
              "结束": "已终止",
              "未知": "未知",
            }[this.listData[i].status]
            this.listData[i].water_status = this.listData[i].water_status === 1 ? '开启' : '关闭'
            this.listData[i].clear_status = this.listData[i].clear_status === 1 ? '开启' : '关闭'
          }
          this.pageparm.currentPage = this.formInline.page;
          this.pageparm.pageSize = this.formInline.limit;
          this.pageparm.total = res.data["total"];
        }
      });
    },
    check_auth(val) {
      return auth(val);
    },
    // 任务分页
    callFather(parm) {
      this.formInline.page = parm.currentPage;
      this.formInline.limit = parm.pageSize;
      this.getTaskData();
    },
    // 搜索任务
    search() {
      this.formInline.page = 1;
      this.getTaskData();
    },

    //车辆单选
    onSelectAllCar() {
      this.$refs.multipleTableCar.clearSelection();
    },
    selectItemCar(rows) {
      if (rows.length > 1) {
        var newRows = rows.filter((it, index) => {
          if (index == rows.length - 1) {
            this.$refs.multipleTableCar.toggleRowSelection(it, true);
            return true;
          } else {
            this.$refs.multipleTableCar.toggleRowSelection(it, false);
            return false;
          }
        });
        this.multipleSelection = newRows;
      } else {
        this.multipleSelection = rows;
      }
    },
    onSelectOpCar(row) {
      this.$refs.multipleTableCar.clearSelection();
      this.$refs.multipleTableCar.toggleRowSelection(row, true);
      this.multipleSelection = [];
      this.multipleSelection.push(row);
    },
    //地图单选
    onSelectAllMap() {
      this.$refs.multipleTableMap.clearSelection();
    },
    selectItemMap(rows) {
      if (rows.length > 1) {
        var newRows = rows.filter((it, index) => {
          if (index == rows.length - 1) {
            this.$refs.multipleTableMap.toggleRowSelection(it, true);
            return true;
          } else {
            this.$refs.multipleTableMap.toggleRowSelection(it, false);
            return false;
          }
        });
        this.multipleSelection = newRows;
      } else {
        this.multipleSelection = rows;
      }
    },
    onSelectOpMap(row) {
      this.$refs.multipleTableMap.clearSelection();
      this.$refs.multipleTableMap.toggleRowSelection(row, true);
      this.multipleSelection = [];
      this.multipleSelection.push(row);
    },
    //车辆修改单选
    onSelectAllCarEdit() {
      this.$refs.multipleTableCars.clearSelection();
    },
    selectItemCarEdit(rows) {
      if (rows.length > 1) {
        var newRows = rows.filter((it, index) => {
          if (index == rows.length - 1) {
            this.$refs.multipleTableCars.toggleRowSelection(it, true);
            return true;
          } else {
            this.$refs.multipleTableCars.toggleRowSelection(it, false);
            return false;
          }
        });
        this.multipleSelection = newRows;
      } else {
        this.multipleSelection = rows;
      }
    },
    onSelectOpCarEdit(row) {
      this.$refs.multipleTableCars.clearSelection();
      this.$refs.multipleTableCars.toggleRowSelection(row, true);
      this.multipleSelection = [];
      this.multipleSelection.push(row);
    },
    //地图修改单选
    onSelectAllMapEdit() {
      this.$refs.multipleTableMaps.clearSelection();
    },
    selectItemMapEdit(rows) {
      if (rows.length > 1) {
        var newRows = rows.filter((it, index) => {
          if (index == rows.length - 1) {
            this.$refs.multipleTableMaps.toggleRowSelection(it, true);
            return true;
          } else {
            this.$refs.multipleTableMaps.toggleRowSelection(it, false);
            return false;
          }
        });
        this.multipleSelection = newRows;
      } else {
        this.multipleSelection = rows;
      }
    },
    onSelectOpMapEdit(row) {
      this.$refs.multipleTableMaps.clearSelection();
      this.$refs.multipleTableMaps.toggleRowSelection(row, true);
      this.multipleSelection = [];
      this.multipleSelection.push(row);
    },
    // 添加任务界面
    addTask() {
      this.dialogVisibleFrom = true;
      this.addForm = {
        electricity_level: "",
        water_status: false,
        clear_status: false,
        id: "",
        name: "",
        vin: "",
        map_id: "",
        map_name_cn: "",
        line_id: "",
        line_name: "",
        remark: "",
        water_level: 0,
        create_time: [],
        stop_time: "",
        run_count: "",
      };
      this.routeShow = false;
    },
    // 选择车辆界面
    selectCar() {
      this.innerVisibleCar = true;
      this.carMapInline.page = 1;
      this.carMapInline.vin = "";
      this.getCar();
    },
    // 选择车辆列表
    getCar() {
      get_cars_task(this.carMapInline).then((res) => {
        if (res["code"] === 0) {
          this.carData = res.data.data;
          this.pagetwo.currentPage = this.carMapInline.page;
          this.pagetwo.pageSize = this.carMapInline.limit;
          this.pagetwo.total = res.data["total"];
        }
      });
    },
    // 车辆分页
    callCar() {
      this.carMapInline.page = this.pagetwo.currentPage;
      this.carMapInline.limit = this.pagetwo.pageSize;
      this.getCar();
    },
    // 搜索车辆
    searchCar() {
      this.carMapInline.page = 1;
      this.getCar();
    },
    // 确认车辆
    chooseCar() {
      this.innerVisibleCar = false;
      for (let i = 0; i < this.multipleSelection.length; i++) {
        this.addForm.vin = this.multipleSelection[i].vin;
      }
    },
    // 修改选择车辆界面
    selectEditCar() {
      this.innerVisibleCarEdit = true;
      this.carMapInline.page = 1;
      this.carMapInline.vin = "";
      this.getEditCar();
    },
    getEditCar() {
      get_cars_task_edit(this.carMapInline, this.editForm.id).then((res) => {
        if (res["code"] === 0) {
          this.carEditData = res.data.data;
          this.pagetwo.currentPage = this.carMapInline.page;
          this.pagetwo.pageSize = this.carMapInline.limit;
          this.pagetwo.total = res.data["total"];
        }
      });
    },
    // 车辆分页
    callEditCar() {
      this.carMapInline.page = this.pagetwo.currentPage;
      this.carMapInline.limit = this.pagetwo.pageSize;
      this.getEditCar();
    },
    // 搜索车辆
    searchEditCar() {
      this.carMapInline.page = 1;
      this.getEditCar();
    },
    // 修改车辆
    chooseEditCar() {
      this.innerVisibleCarEdit = false;
      for (let i = 0; i < this.multipleSelection.length; i++) {
        this.editForm.vin = this.multipleSelection[i].vin;
      }
    },
    // 选择地图界面
    selectMap() {
      this.innerVisibleMap = true;
      this.carMapInline.page = 1;
      this.carMapInline.map_name_cn = "";
      this.getMap();
    },
    // 选择地图列表
    async getMap() {
      return get_map_task(this.carMapInline).then((res) => {
        if (res["code"] === 0) {
          this.gridData = res.data.data;
          this.pagetwo.currentPage = this.carMapInline.page;
          this.pagetwo.pageSize = this.carMapInline.limit;
          this.pagetwo.total = res.data["total"];
        }
      });
    },
    // 地图分页
    callMap() {
      this.carMapInline.page = this.pagetwo.currentPage;
      this.carMapInline.limit = this.pagetwo.pageSize;
      this.getMap();
    },
    // 搜索地图
    searchMap() {
      this.carMapInline.page = 1;
      this.getMap();
    },
    // 确认地图
    chooseMap() {
      this.innerVisibleMap = false;
      this.routeShow = true;
      for (let i = 0; i < this.multipleSelection.length; i++) {
        if (this.addForm.map_name_cn != undefined) {
          if (
            this.addForm.map_name_cn != this.multipleSelection[i].map_name_cn
          ) {
            this.addForm.line_name = "";
            this.destroy = true;
          }
        }
        this.addForm.map_id = this.multipleSelection[i].id;
        this.addForm.map_name_cn = this.multipleSelection[i].map_name_cn;
      }
    },
    selectEditMap() {
      this.innerVisibleMapEdit = true;
      this.carMapInline.page = 1;
      this.carMapInline.map_name_cn = "";
      this.getMap();
    },
    // 修改地图
    chooseEditMap() {
      this.innerVisibleMapEdit = false;
      for (let i = 0; i < this.multipleSelection.length; i++) {
        if (
          this.editForm.map_name_cn != this.multipleSelection[i].map_name_cn
        ) {
          this.editForm.line_id = "";
          this.editForm.line_name = "";
          this.destroy = true;
        }
        this.editForm.map_id = this.multipleSelection[i].id;
        this.editForm.map_name_cn = this.multipleSelection[i].map_name_cn;
      }
    },
    //导入车辆id
    handleSelectionChange(val) {
      this.idsval = [];
      for (let i in val) {
        //去重以免发生意外的push
        if (!this.idsval.includes(val[i])) {
          this.idsval.push(val[i]);
        }
      }
    },
    toggleRowSelect() {
      this.$nextTick(() => {
        if (this.$refs.multipleTablesLine) {
          this.$refs.multipleTablesLine.clearSelection();
        }
      });
    },
    toggleRowSelectEditLine() {
      this.$nextTick(() => {
        if (this.$refs.multipleTables) {
          this.$refs.multipleTables.clearSelection();
        }
      });
    },
    // 选择线路界面
    selectLine() {
      this.innerVisibleRouteLine = true;
      this.ids = [];
      this.line_names = [];
      this.addForm.line_id = "";
      this.addForm.line_name = "";
      if (this.destroy) {
        this.toggleRowSelect();
        this.destroy = false;
      }
      this.carMapInline.page = 1;
      this.carMapInline.name_cn = "";
      this.getLine();
    },
    // 选择线路列表
    getLine() {
      get_line_task(this.carMapInline, this.addForm.map_id).then((res) => {
        if (res["code"] === 0) {
          this.lineData = res.data.data;
          this.pagetwo.currentPage = this.carMapInline.page;
          this.pagetwo.pageSize = this.carMapInline.limit;
          this.pagetwo.total = res.data["total"];
        }
      });
    },
    //打开选择路线的  编辑页面
    selectEditLine() {
      this.innerVisibleRoute = true;
      this.ids = [];
      this.line_names = [];
      this.editForm.line_id = "";
      this.editForm.line_name = "";
      if (this.destroy) {
        this.toggleRowSelectEditLine();
        this.destroy = false;
      }
      this.carMapInline.page = 1;
      this.carMapInline.name_cn = "";
      this.getEditLine();
    },

    // 渲染 选择线路的 值
    getEditLine() {
      get_line_task(this.carMapInline, this.editForm.map_id).then((res) => {
        if (res["code"] === 0) {
          this.lineData = res.data.data;
          this.pagetwo.currentPage = this.carMapInline.page;
          this.pagetwo.pageSize = this.carMapInline.limit;
          this.pagetwo.total = res.data["total"];
        }
      });
    },
    // 线路分页
    callLine() {
      this.carMapInline.page = this.pagetwo.currentPage;
      this.carMapInline.limit = this.pagetwo.pageSize;
      this.getLine();
    },
    // 线路分页
    callEditLine() {
      this.carMapInline.page = this.pagetwo.currentPage;
      this.carMapInline.limit = this.pagetwo.pageSize;
      this.getEditLine();
    },
    // 搜索线路
    searchLine() {
      this.carMapInline.page = 1;
      this.getLine();
    },
    // 确认线路
    chooseRoute() {
      this.innerVisibleRouteLine = false;
      for (var i = 0; i < this.idsval.length; i++) {
        this.ids.push(this.idsval[i].id);
        this.line_names.push(this.idsval[i].name_cn);
      }
      var str = this.ids.join(",");
      var strs = this.line_names.join(",");
      this.addForm.line_id = str;
      this.addForm.line_name = strs;
      this.kongzhi = true;
    },
    // 确定 修改线路
    chooseEditRoute() {
      this.innerVisibleRoute = false;
      for (var i = 0; i < this.idsval.length; i++) {
        this.ids.push(this.idsval[i].id);
        this.line_names.push(this.idsval[i].name_cn);
      }
      var str = this.ids.join(",");
      var strs = this.line_names.join(",");
      this.editForm.line_id = str;
      this.editForm.line_name = strs;
      str = "";
      strs = "";
      this.kongzhi = true;
    },
    // 添加保存
    submitAddForm(addData) {
      this.$refs[addData].validate((valid) => {
        if (valid) {
          let start_time = this.addForm.create_time[0];
          let end_time = this.addForm.create_time[1];
          (this.addForm.water_status = this.addForm.water_status === true ? 1 : 0),
            (this.addForm.clear_status =
              this.addForm.clear_status === true ? 1 : 0);
          console.log(this.addForm.water_level);
          get_add_task(this.addForm, start_time, end_time).then((res) => {
            this.dialogVisibleFrom = false;
            this.loading = false;
            if (res["code"] === 0) {
              this.getTaskData();
              this.addForm = {};
              this.$message.success(res["message"]);
              this.toggleRowSelect();
            }
          });
        } else {
          return false;
        }
      });
    },
    // 显示修改界面
    async editTask(row) {
      this.editForm = {};
      await this.getMap();
      await get_one_task(row.id).then((res) => {
        if (res["code"] === 0) {
          this.editForm = res.data;
          this.$set(this.editForm, "create_time", [
            res.data.start_time,
            res.data.end_time,
          ]);
          this.editForm.water_status =
            this.editForm.water_status === 0 ? false : true;
          this.editForm.clear_status =
            this.editForm.clear_status === 0 ? false : true;
          this.routeShow = true;
          for (let i = 0; i < this.gridData.length; i++) {
            if (this.editForm.map_id == this.gridData[i].id) {
              this.editForm.map_name_cn = this.gridData[i].map_name_cn;
            }
          }
        }
      });
      this.dialogVisible = true;
    },
    // 修改保存
    submitForm(editData) {
      this.$refs[editData].validate((valid) => {
        if (valid) {
          let start_time = this.editForm.create_time[0];
          let end_time = this.editForm.create_time[1];
          (this.editForm.water_status =
            this.editForm.water_status === true ? 1 : 0),
            (this.editForm.clear_status =
              this.editForm.clear_status === true ? 1 : 0);
          get_edit_task(this.editForm, start_time, end_time).then((res) => {
            this.dialogVisible = false;
            this.loading = false;
            if (res["code"] === 0) {
              this.getTaskData();
              this.$message.success(res["message"]);
            }
          });
        } else {
          return false;
        }
      });
    },
    // 修改状态
    changeStatus(row) {
      this.loading = true
      this.timerLoad = setTimeout(() => {
        this.loading = false
      }, 5000)
      get_switch_status(row.id, row["status"] == "未开始" || row["status"] == "已终止" ? 1 : 0).then(
        (res) => {
          if (res["code"] === 0) {
            this.loading = false
            this.start = true;
            this.getTaskData();
            this.$message.success(res["message"]);
          }
        }
      );
    },
    suspendStatus(row) {
      this.loading = true
      this.timerLoad = setTimeout(() => {
        this.loading = false
      }, 5000)
      get_switch_status(row.id, row["status"] == "进行中" ? 2 : 3).then((res) => {
        if (res["code"] === 0) {
          this.loading = false
          this.start = !this.start;
          this.getTaskData();
          this.$message.success(res["message"]);
        }
      });
    },
    clear() {
      clearInterval(this.timer);
      this.timer = null;
    },
    handleClick() {
      if (this.activeName == "first") {
        this.getTaskData();
        this.timer = setInterval(() => {
          this.getTaskData();
        }, 2000)
      }
      if (this.activeName == "second") {
        this.$refs.child.$emit("childmethod"); //子组件$on中的名字
        this.clear()
      }
      if (this.activeName == "third") {
        this.$refs.childer.$emit("childmethod"); //子组件$on中的名字
        this.clear()
      }
    },
    // 删除公司
    deleteUser(row) {
      this.$confirm("确定要删除吗?", "信息", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          get_del_task(row.id).then((res) => {
            if (res["code"] === 0) {
              this.$message.success(res["message"]);
              if (this.listData.length === 1) {
                if (this.formInline.page === 1) {
                  this.getTaskData();
                } else {
                  this.formInline.page = this.formInline.page - 1;
                  this.getTaskData();
                }
              } else {
                this.getTaskData();
              }
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    // 车辆
    handleSizeChange(val) {
      this.pagetwo.pageSize = val;
      this.callCar();
    },
    handleCurrentChange(val) {
      this.pagetwo.currentPage = val;
      this.callCar();
    },
    handleEditSizeChange(val) {
      this.pagetwo.pageSize = val;
      this.callEditCar();
    },
    handleEditCurrentChange(val) {
      this.pagetwo.currentPage = val;
      this.callEditCar();
    },
    // 地图
    handleMapSizeChange(val) {
      this.pagetwo.pageSize = val;
      this.callMap();
    },
    handleMapCurrentChange(val) {
      this.pagetwo.currentPage = val;
      this.callMap();
    },
    // 线路
    handleLineSizeChange(val) {
      this.pagetwo.pageSize = val;
      this.callLine();
    },
    handleLineCurrentChange(val) {
      this.pagetwo.currentPage = val;
      this.callLine();
    },
    // 线路
    handleLinesSizeChange(val) {
      this.pagetwo.pageSize = val;
      this.callEditLine();
    },
    handleLinesCurrentChange(val) {
      this.pagetwo.currentPage = val;
      this.callEditLine();
    },
    // 关闭编辑、增加弹出框
    closeDialog() {
      this.dialogVisibleFrom = false;
      this.innerVisibleCar = false;
      this.innerVisibleMap = false;
      this.innerVisibleMapEdit = false;
      this.toggleRowSelect();
      this.toggleRowSelectEditLine();
      this.innerVisibleCarEdit = false;
      this.dialogVisible = false;
    },
    closeLineDialog() {
      this.innerVisibleRouteLine = false;
      if (!this.kongzhi) {
        this.toggleRowSelect();
      }
      this.kongzhi = false;
    },
    closeLineEditDialog() {
      this.innerVisibleRoute = false;
      if (!this.kongzhi) {
        this.toggleRowSelectEditLine();
      }
      this.kongzhi = false;
    },
  },
};
</script>
<style scoped>
.head {
  width: 99%;
  padding-bottom: 1%;
  margin-top: 1%;
  margin-left: 1%;
  font-size: 20px;
  color: #334157;
}

/* 添加编辑弹框 */
.chooseMap {
  margin-top: 1%;
  width: 100%;
  height: 30px;
  line-height: 30px;
  /* background-color: violet; */
  border: #dcdfe6 1px solid;
  border-radius: 3px;
}

.in_chooseMap {
  height: 30px;
  display: flex;
  justify-content: space-between;
  color: #888;
  margin-right: 2%;
}
</style>


// WEBPACK FOOTER //
// src/views/region_mn/task_mn.vue